<template>
  <div class="holiday-closure">
    <table class="holiday-table">
      <thead>
        <tr>
          <th>{{ $t('dialog.body.openinghours.table.day') }}</th>
          <th>{{ $t('dialog.body.openinghours.table.openinghours') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="day in standardHours" :key="day.dayOfWeek">
          <td>{{ getDayOfWeek(day.dayOfWeek) }}</td>
          <td>
            <span v-if="day.startTime === 'Closed All Day'">
              ❌ {{ $t('dialog.body.openinghours.closedallday') }}
            </span>
            <span v-else>
              🕒 {{ day.startTime }} - {{ day.endTime }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  standardHours: {
    type: Array,
    required: true
  }
})

function getDayOfWeek(englishWeekday) {
  const days = {
    Monday: t('dialog.body.openinghours.table.monday'),
    Tuesday: t('dialog.body.openinghours.table.tuesday'),
    Wednesday: t('dialog.body.openinghours.table.wednesday'),
    Thursday: t('dialog.body.openinghours.table.thursday'),
    Friday: t('dialog.body.openinghours.table.friday'),
    Saturday: t('dialog.body.openinghours.table.saturday'),
    Sunday: t('dialog.body.openinghours.table.sunday')
  }
  return days[englishWeekday] || englishWeekday
}
</script>

<style scoped>
.holiday-closure {
  text-align: center;
  padding: 20px;
}

.holiday-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.holiday-table th,
.holiday-table td {
  padding: 10px;
  border: 1px solid #ddd;
}
</style>
